import React, { useReducer } from 'react'

import type { IParam } from 'libs/apis'
import type { IBranchSingleProps, IBranchSinglePropsPartial } from './model'

import { initialState, reducer, BranchContext } from './context'

export function withBranch(PageComponent: React.FC) {
  return function EnhancedComponent<T>(props: T): JSX.Element {
    const [state, dispatch] = useReducer(reducer, initialState)

    const updateBranches = (
      newBranch: IBranchSingleProps[],
      page: number,
      searchParams: IParam & IBranchSinglePropsPartial,
    ): void => {
      dispatch({ type: 'UPDATE', payload: { newBranch, page, searchParams } })
    }

    return (
      <BranchContext.Provider value={{ ...state, updateBranches }}>
        <PageComponent {...props} />
      </BranchContext.Provider>
    )
  }
}
